<div id="layout" class="sign_in f_col">
  <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{'preenroll.title' | translate}}</app-view-title>
  <div class="scroll_wrapper">
    <app-view-deco-image class="mt_20 mb_20" imageUrl="assets-projects/images/image_explanation.svg"></app-view-deco-image>
    <app-snackbar *ngIf="cart?.cartDatas.fromRoute === 'person'" Icon="check" class="mb_10 f_center">{{cart?.actualPerson?.firstName + ' ' + cart?.actualPerson?.lastName}}</app-snackbar>
    <div class="mb_40">
      <p class="text_center mb_40">{{'preenroll.description' | translate}}</p>
      <p class="text_center mb_40">{{'passportPage.select' | translate}}</p>
      <app-slide-element leftIcon="passport" (btnClicked)="nav.to(cart.scenario === 'document' ? 'people' : 'means-payment')" class="mt_20">
        {{(cart?.cartDatas?.fromRoute === 'document' ? 'passportPage.choosePerson' : 'passportPage.askPassport') | translate}}
      </app-slide-element>
    </div>
  </div>
  <div class="f_align_end f_grow mb_20">
    <app-back-btn icon="house" (btnClicked)="nav.to('dashboard')"></app-back-btn>
    <div class="ml_10 fullWidth">
      <app-button color="transparent" border="true" formId="form" class="fullWidth" (btnClicked)="onBack()" >{{'global.back' | translate}}</app-button>
    </div>
  </div>
</div>
